import { render, staticRenderFns } from "./fancyText.vue?vue&type=template&id=777ed378"
import script from "./fancyText.vue?vue&type=script&lang=js"
export * from "./fancyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fancyText.vue"
export default component.exports